import apiCall from "../axios/apiCall";

const controller = "catalogos";

export default {
    getEstados: async () => {  
        let response = { success: true };
        const method = `estados`;
        try {  
          const apiResponse = await apiCall.get(controller, method);
          response.data = apiResponse?.data;
        } catch (error) {
          response = apiCall.handleCatch(error);
        }
        return response;
    },
    getMunicipios: async () => {  
        let response = { success: true };
        const method = `municipios`;
        try {  
          const apiResponse = await apiCall.get(controller, method); 
          response.data = apiResponse?.data;
        } catch (error) {
          response = apiCall.handleCatch(error);
        }
        return response;
    },
    getMunicipiosByEstado: async (id_estado) => {
        let response = { success: true };
        const method = `municipios/${id_estado}`;
        try {  
          const apiResponse = await apiCall.get(controller, method); 
          response.data = apiResponse?.data;
        } catch (error) {
          response = apiCall.handleCatch(error);
        }
        return response;
    },
    getLocalidades: async () => {  
        let response = { success: true };
        const method = `localidades`;
        try {  
          const apiResponse = await apiCall.get(controller, method); 
          response.data = apiResponse?.data;
        } catch (error) {
          response = apiCall.handleCatch(error);
        }
        return response;
    },
    getLocalidadesByCP: async (codigo_postal) => {  
        let response = { success: true };
        const method = `localidades/${codigo_postal}`;
        try {  
          const apiResponse = await apiCall.get(controller, method); 
          response.data = apiResponse?.data;
        } catch (error) {
          response = apiCall.handleCatch(error);
        }
        return response;
    },
    getCarreras: async () => {  
        let response = { success: true };
        const method = `carreras`;
        try {  
          const apiResponse = await apiCall.get(controller, method); 
          response.data = apiResponse?.data;
        } catch (error) {
          response = apiCall.handleCatch(error);
        }
        return response;
    },
}